import { Global } from "@emotion/react/macro";
import normalize from "emotion-normalize";
import { base } from "./base";
import { reset } from "./reset";

export const GlobalStyles: React.FC = () => (
  <Global styles={[normalize, reset, base]} />
);
